export default "__VITE_ASSET__B643Zlod__"